import '../plugins/custom-select.min.js';

const types = document.querySelector('#filter-types');
const brands = document.querySelector('#filter-brands');
const facilities = document.querySelector('#filter-facilities');

let selectedType = types.value ? types.value : '';
let selectedBrand = brands.value ? brands.value : '';
let selectedFacility = facilities.value ? facilities.value : '';

const loader = document.querySelector('#loading');
const target = document.querySelector('#service-target');

const url = document.querySelector('#url').value;

const loadMoreBtn = document.querySelector('#load-more');
let page = 1;

if(loadMoreBtn) {
    loadMoreBtn.addEventListener('click', showMoreServices);
}

if(types && brands && facilities) {
    customSelect(types);
    customSelect(brands);
    customSelect(facilities);

    // Filtrera
    types.customSelect.select.addEventListener('change', filterServices);
    brands.customSelect.select.addEventListener('change', filterServices);
    facilities.customSelect.select.addEventListener('change', filterServices);

    // Uppdatear filter
    types.customSelect.select.addEventListener('change', updateFacilities);
    brands.customSelect.select.addEventListener('change', updateFacilities);
    facilities.customSelect.select.addEventListener('change', updateServices);
    facilities.customSelect.select.addEventListener('change', updateBrands);

}

showMoreServices();

function filterServices(e) {
    if(e.srcElement.id === 'filter-types') {
        selectedType = e.srcElement.value;
    } else if(e.srcElement.id === 'filter-brands') {
        selectedBrand = e.srcElement.value;
    } else {
        selectedFacility = e.srcElement.value;
    }

    loader.style.display = 'inline-block';
    target.innerHTML = '';

    const form = new FormData();
    form.append('action', 'nobox_filter_services');
    form.append('brand', selectedBrand);
    form.append('type', selectedType);
    form.append('facility', selectedFacility);
    form.append('url', url);

    const params = new URLSearchParams(form);

    fetch(horizon.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params
    })
    .then(response => response.json())
    .then(data => {
        target.innerHTML = data.html;
        loader.style.display = 'none';
    })
}

function updateServices(e) {
    const form = new FormData();
    form.append('action', 'nobox_update_services');
    form.append('facility', e.srcElement.value);

    const params = new URLSearchParams(form);

    fetch(horizon.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params
    })
    .then(response => response.json())
    .then(data => {
        types.customSelect.destroy();
        types.innerHTML = "";
        customSelect(types);

        let option = document.createElement('option');
        option.innerHTML = 'Alla tjänster';
        option.value = '';
        types.customSelect.append(option);

        data.forEach(item => {
            if(item) {
                option = document.createElement('option');
                option.innerHTML = item.name;
                option.value = item.slug;

                types.customSelect.append(option);
            }
        })
    })
}

function updateBrands(e) {
    const form = new FormData();
    form.append('action', 'nobox_update_brands');
    form.append('facility', e.srcElement.value);

    const params = new URLSearchParams(form);

    fetch(horizon.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params
    })
    .then(response => response.json())
    .then(data => {
        brands.customSelect.destroy();
        brands.innerHTML = "";
        customSelect(brands);

        let option = document.createElement('option');
        option.innerHTML = 'Alla märken';
        option.value = '';
        brands.customSelect.append(option);

        data.forEach(item => {
            if(item) {
                option = document.createElement('option');
                option.innerHTML = item.name;
                option.value = item.slug;

                brands.customSelect.append(option);
            }
        })
    })
}

function updateFacilities(e) {
    const form = new FormData();
    form.append('action', 'nobox_update_facilities');
    form.append('service', selectedType);
    form.append('brand', selectedBrand);

    const params = new URLSearchParams(form);

    fetch(horizon.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params
    })
    .then(response => response.json())
    .then(data => {
        facilities.customSelect.destroy();
        facilities.innerHTML = "";
        customSelect(facilities);

        let option = document.createElement('option');
        option.innerHTML = 'Alla anläggningar';
        option.value = '';
        facilities.customSelect.append(option);

        data.forEach((item, index) => {
            if(item) {
                option = document.createElement('option');
                option.innerHTML = item.namn;
                option.value = index;

                facilities.customSelect.append(option);
            }
        })
    })
}

function showMoreServices(e) {
    let button;
    if(e && e.srcElement) {
        page++; // Öka endast om användare klickar på knapp
        button = e.srcElement;
    } else {
        button = loadMoreBtn;
    }
    button.style.display = 'none';

    let count;
    if(screen.width < 600) {
        count = button.dataset.countMobile;
    } else {
        count = button.dataset.count;
    }

    loader.style.display = 'inline-block';

    const form = new FormData();
    form.append('action', 'nobox_filter_services');
    form.append('brand', selectedBrand);
    form.append('type', selectedType);
    form.append('facility', selectedFacility);
    form.append('count', count);
    form.append('page', page);
    form.append('url', url);

    const params = new URLSearchParams(form);

    fetch(horizon.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params
    })
    .then(response => response.json())
    .then(data => {
        target.innerHTML += data.html;
        loader.style.display = 'none';

        if(data.no_more) {
            button.style.display = 'none';
        } else {
            button.style.display = 'inline-block';
        }
    })
}
